import { supabase } from '../supabase/client';

// Pro E-Mail: wurde mindestens ein Anhang über die halbautomatische Drive-Ablage abgelegt?
// Marker: dokument_ablage_vorschlaege.status = 'abgelegt' — unabhängig vom Rechnungs-Import
// (der über email_anhaenge.rechnung_status läuft, siehe emailRechnungStatus.ts).
export async function ladeAblageStatusFuerEmails(
  emailIds: string[],
): Promise<Record<string, boolean>> {
  if (emailIds.length === 0) return {};

  // In 100er-Batches: .in() mit sehr vielen UUIDs sprengt sonst die GET-URL (414 URI Too Long).
  const CHUNK = 100;
  const batches: string[][] = [];
  for (let i = 0; i < emailIds.length; i += CHUNK) batches.push(emailIds.slice(i, i + CHUNK));

  const results = await Promise.all(
    batches.map((b) =>
      supabase.from('dokument_ablage_vorschlaege').select('email_id').eq('status', 'abgelegt').in('email_id', b),
    ),
  );

  const map: Record<string, boolean> = {};
  for (const { data, error } of results) {
    if (error) {
      console.error('Ablage-Status laden fehlgeschlagen', error.message);
      continue;
    }
    for (const r of data || []) map[(r as any).email_id as string] = true;
  }
  return map;
}
